function initBookingWidget() {
    let $triggers = $('.booking-widget__link');
    $triggers.each(function(){
        // init
        let $trigger = $(this);
        if ($trigger.is(':hidden')) {
            return true;
        }
        $trigger.on('click', function(e){
            // init
            e.preventDefault();
            let $trigger = $(this);
            let $booking_widget = $trigger.parents('.booking-widget');
            let base_url = 'https://gc.synxis.com/rez.aspx?Hotel=60669&start=availresults&locale=de-DE';
            let parameters = '';
            // form URL from values
            let arrival_date = $booking_widget.find('[data-arrival-date]').val();
            if (arrival_date) {
                parameters += '&arrive='+arrival_date;
            }
            let departure_date = $booking_widget.find('[data-departure-date]').val();
            if (departure_date) {
                parameters += '&depart='+departure_date;
            }
            let nr_of_people = $booking_widget.find('[data-nr-of-people]').val();
            if (nr_of_people) {
                parameters += '&adult='+nr_of_people;
            }
            let nr_of_rooms = $booking_widget.find('[data-nr-of-rooms]').val();
            if (nr_of_rooms) {
                parameters += '&rooms='+nr_of_rooms;
            }
            window.open(base_url + parameters, '_blank');
        });
    })
}

// on page load
initBookingWidget();

$(window).on('default-modal:opened', function(){
    initBookingWidget();
});



// WEBPACK FOOTER //
// ./static/js/modules/booking-widget.js